/**
 * Centralized icon exports to avoid naming conflicts
 * All lucide-react icons used in the application
 */

import {
  Home as HomeIcon,
  Play as PlayIcon,
  MessageCircle as MessageCircleIcon,
  Bell as BellIcon,
  User as UserIcon,
  Settings as SettingsIcon,
  Shield as ShieldIcon,
  Users as UsersIcon,
  FileText as FileTextIcon,
  Radio as RadioIcon,
  Video as VideoIcon,
  UserCheck as UserCheckIcon,
  Webhook as WebhookIcon,
  Plus as PlusIcon,
  ChevronLeft as ChevronLeftIcon,
  LogOut as LogOutIcon,
  Sun as SunIcon,
  Moon as MoonIcon,
  Monitor as MonitorIcon,
  Check as CheckIcon,
  HelpCircle as HelpCircleIcon,
  Search as SearchIcon,
  Filter as FilterIcon,
  Heart as HeartIcon,
  BarChart3 as BarChart3Icon,
  ToggleLeft as ToggleLeftIcon,
  ToggleRight as ToggleRightIcon,
  AlertCircle as AlertCircleIcon,
  Clock as ClockIcon,
  Eye as EyeIcon,
  EyeOff as EyeOffIcon,
  Trash2 as Trash2Icon,
  Pencil as PencilIcon,
  MoreHorizontal as MoreHorizontalIcon,
  Lock as LockIcon,
  Calendar as CalendarIcon,
  LoaderCircle as LoadingSpinnerIcon,
  Image as ImageIcon,
} from 'lucide-react';

// Export all icons with unique names
export {
  HomeIcon,
  PlayIcon,
  MessageCircleIcon,
  BellIcon,
  UserIcon,
  SettingsIcon,
  ShieldIcon,
  UsersIcon,
  FileTextIcon,
  RadioIcon,
  VideoIcon,
  UserCheckIcon,
  WebhookIcon,
  PlusIcon,
  ChevronLeftIcon,
  LogOutIcon,
  SunIcon,
  MoonIcon,
  MonitorIcon,
  CheckIcon,
  HelpCircleIcon,
  SearchIcon,
  FilterIcon,
  HeartIcon,
  BarChart3Icon,
  ToggleLeftIcon,
  ToggleRightIcon,
  AlertCircleIcon,
  ClockIcon,
  EyeIcon,
  EyeOffIcon,
  Trash2Icon,
  PencilIcon,
  MoreHorizontalIcon,
  LockIcon,
  CalendarIcon,
  LoadingSpinnerIcon,
  ImageIcon,
};

// Icon name to component mapping
export const iconMap: Record<string, any> = {
  Home: HomeIcon,
  Play: PlayIcon,
  MessageCircle: MessageCircleIcon,
  Bell: BellIcon,
  User: UserIcon,
  Settings: SettingsIcon,
  Shield: ShieldIcon,
  Users: UsersIcon,
  FileText: FileTextIcon,
  Radio: RadioIcon,
  Video: VideoIcon,
  UserCheck: UserCheckIcon,
  Webhook: WebhookIcon,
  Plus: PlusIcon,
  ChevronLeft: ChevronLeftIcon,
  LogOut: LogOutIcon,
  Sun: SunIcon,
  Moon: MoonIcon,
  Monitor: MonitorIcon,
  Check: CheckIcon,
  HelpCircle: HelpCircleIcon,
  Search: SearchIcon,
  Filter: FilterIcon,
  Heart: HeartIcon,
  BarChart3: BarChart3Icon,
  ToggleLeft: ToggleLeftIcon,
  ToggleRight: ToggleRightIcon,
  AlertCircle: AlertCircleIcon,
  Clock: ClockIcon,
  Eye: EyeIcon,
  EyeOff: EyeOffIcon,
  Trash2: Trash2Icon,
  Pencil: PencilIcon,
  MoreHorizontal: MoreHorizontalIcon,
  Lock: LockIcon,
  Calendar: CalendarIcon,
  LoadingSpinner: LoadingSpinnerIcon,
  Image: ImageIcon,
};

// Helper function to get icon component by name
export function getIconComponent(iconName: string): any {
  return iconMap[iconName] || HomeIcon;
}